import React, { useState } from "react";
import { RouteComponentProps } from "react-router";
import { ComponentStatus } from "../../components";
import { getToken } from "../../shared/utils/LocalSessionHandler";
import { SessionService } from "../../services";
import {
    BackImgContainer,
    WhiteTableContainer,
} from "../../components/Containers";
import { JumpBtn, BackBtn } from "../../components/Buttons";
import { ThisPaths } from "../../shared/Constants";
import { EmailInput } from "../../components/Inputs";
import {
    useFormInput,
    useWindowDimension,
} from "../../shared/utils/CustomHooks";
import { MainLogo, UserSessionSpan } from "./MainLogo";
import { toast } from "react-toastify";

const ForgotPassword: React.FC<RouteComponentProps> = (props) => {
    const { history } = props;
    const email = useFormInput("");
    const [error, setError] = useState<string>("");
    const [status, setStatus] = useState<ComponentStatus>("complete");
    const dimensions = useWindowDimension();

    // handle button click of login form
    const handleLogin = async () => {
        setStatus("loading");
        const token = getToken();
        const sr = await SessionService.RecoverPassword({
            token: token!,
            email: email.value,
        });

        if (sr.status()) {
            toast.success("El email se envio correctamente!!");
            history.push(ThisPaths.LOGIN);
        } else {
            setStatus("errored");
            setError(sr.getParsedError());
        }
    };

    return (
        <BackImgContainer disabledImg={window.innerWidth < 1000} inActiveHeader>
            <WhiteTableContainer
                style={
                    dimensions.height <= 667
                        ? { height: (dimensions.height * 70) / 100 }
                        : undefined
                }
            >
                <MainLogo />
                <UserSessionSpan>
                    Ingrese la dirección de email de su cuenta comedor,
                    y le enviaremos un link de activacion.
                </UserSessionSpan>
                <EmailInput
                    {...email}
                    placeholder="Ingrese su casilla de email"
                    style={{ margin: "4%" }}
                />
                {status === "errored" && (
                    <>
                        <small style={{ color: "red" }}>{error}</small>
                        <br />
                    </>
                )}
                <br />
                <div
                    style={{
                        display: "inline-flex",
                        width: "100%",
                        justifyContent: "space-around",
                    }}
                >
                    <JumpBtn
        		        borderColor={"#0053a0"}
                        colorOnHover={"#0053a0"}
                        value={status === "loading" ? "Cargando..." : "Enviar"}
                        onClick={handleLogin}
                        disabled={status === "loading"}
                    />
                    <BackBtn />
                </div>

                <br />
            </WhiteTableContainer>
        </BackImgContainer>
    );
};

export default ForgotPassword;
